import script from "./GroupCoachingDigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupCoachingDigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"

import "./GroupCoachingDigitalSignatureForm.vue?vue&type=style&index=0&id=625762dd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-625762dd"]])

export default __exports__